An array of phone numbers for the person.

The phone numbers are ordered in descending preference.

This field is redacted and an empty array is returned when a candidate or job application is deleted.
